import { GenerateTenantUserActivationLinkRequestSchema, GenerateTenantUserActivationLinkResponseSchema } from './generate-tenant-user-activation-link.schema';
/**
 * Generate Tenant User Activation Link Endpoint Contract
 * Mints a fresh activation link for a tenant user so a super-admin can deliver
 * it manually (e.g. when the invitation email was lost to spam). Does not send
 * an email; rotating the token invalidates any previously emailed link.
 */ export const generateTenantUserActivationLinkContract = {
    method: 'POST',
    path: '/api/v2/tenants/:tenantId/users/:userId/activation-link',
    description: 'Generate a fresh activation link for a tenant user',
    requestSchema: GenerateTenantUserActivationLinkRequestSchema,
    responseSchema: GenerateTenantUserActivationLinkResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Bad Request - user is not inactive or pending',
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - user is not a super-admin',
            404: 'User or tenant not found',
            409: 'Conflict - user already has login credentials',
            503: 'Service Unavailable - identity provider unreachable'
        }
    }
};

//# sourceMappingURL=generate-tenant-user-activation-link.contract.js.map